import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';
import logoImg from '../../assets/images/talktokam.webp';

const expand = keyframes`
  0% { transform: scale(0.4); opacity: 0.7; }
  100% { transform: scale(2.2); opacity: 0; }
`;

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

const shimmer = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const rings = [
  { delay: '0s', size: 160 },
  { delay: '0.6s', size: 160 },
  { delay: '1.2s', size: 160 },
  { delay: '1.8s', size: 160 },
];

const LogoLoader = ({ fullScreen = true, message, size = 80 }) => {
  const ringSize = size * 2;
  const logoSize = size * 0.7;

  const content = (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: 2.5,
    }}>
      <Box sx={{
        position: 'relative', width: ringSize, height: ringSize,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        {/* Expanding ripple rings behind the logo */}
        {rings.map((r, i) => (
          <Box key={i} sx={{
            position: 'absolute', width: r.size, height: r.size,
            borderRadius: '50%',
            border: '2.5px solid',
            borderColor: i % 2 === 0 ? '#6366f1' : '#8b5cf6',
            animation: `${expand} 2.4s ease-out ${r.delay} infinite`,
          }} />
        ))}

        {/* Rotating gradient disc behind logo */}
        <Box sx={{
          position: 'absolute', width: logoSize + 16, height: logoSize + 16,
          borderRadius: '50%',
          background: 'conic-gradient(from 0deg, #6366f1, #8b5cf6, #a78bfa, #c084fc, #6366f1)',
          animation: `${rotate} 3s linear infinite`,
        }} />

        {/* Logo container */}
        <Box sx={{
          width: logoSize, height: logoSize, borderRadius: '50%', overflow: 'hidden',
          animation: `${pulse} 2s ease-in-out infinite`,
          boxShadow: '0 0 30px rgba(99,102,241,0.35), 0 0 60px rgba(139,92,246,0.15)',
          position: 'relative', zIndex: 1,
          border: '3px solid rgba(255,255,255,0.9)',
        }}>
          <Box component="img" src={logoImg} alt="talktokam"
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </Box>
      </Box>
      {message && (
        <Box sx={{
          fontSize: 13, fontWeight: 600,
          background: 'linear-gradient(270deg, #6366f1, #8b5cf6, #a78bfa, #c084fc, #6366f1)',
          backgroundSize: '300% 100%',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          animation: `${shimmer} 3s ease infinite`,
        }}>
          {message}
        </Box>
      )}
    </Box>
  );

  if (fullScreen) {
    return (
      <Box sx={{
        position: 'fixed', inset: 0, zIndex: 99999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        bgcolor: '#f8faff',
      }}>
        {content}
      </Box>
    );
  }

  return content;
};

export default LogoLoader;
